var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeoFance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.29688,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 9.5,
    fill: "#9C4900",
    stroke: "#F6EFE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9635 18.0807V15.8307H21.6302V19.1641L14.1302 22.4974L8.29688 16.6641L11.6302 9.16406H14.9635V10.8307H12.7135L10.2969 16.3307L14.4635 20.4974L19.9635 18.0807ZM24.1302 9.16406V10.8307H21.6302V13.3307H19.9635V10.8307H17.4635V9.16406H19.9635V6.66406H21.6302V9.16406H24.1302Z",
    fill: "#F6EFE9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoFance);
export default __webpack_public_path__ + "static/media/Geo-fance.2e75a14f87935856ca15c17b54a2feff.svg";
export { ForwardRef as ReactComponent };